import { m as motion } from "motion/react";
import { useAnimateFadeIn } from "../../../animation/animation";
import styles from "./welcome-text.module.less";

export type TWelcomeTextProps = {
  textStart: string;
  textEnd: string;
  logoUrl?: string;
};

export const WelcomeText = ({ textStart, textEnd, logoUrl }: TWelcomeTextProps) => {
  const fadeInAnimation = useAnimateFadeIn({ whileInView: true, easing: "easeInOut" });

  return (
    <section className={styles.wrapper}>
      <motion.div {...fadeInAnimation} className={"max-width centered padded-sides"}>
        <div className={styles.innerWrapper}>
          {logoUrl && <img className={styles.topLogo} src={logoUrl ?? undefined} alt={"Preem logo"} />}
          <h1 className={logoUrl ? "mb-0" : ""}>
            <span className={styles.textStart}>{textStart}</span> {textEnd}
          </h1>
        </div>
      </motion.div>
    </section>
  );
};

export default WelcomeText;
